import { render, staticRenderFns } from "./BalanceCollectionRecord.vue?vue&type=template&id=ce4b0088&scoped=true"
import script from "./BalanceCollectionRecord.vue?vue&type=script&lang=js"
export * from "./BalanceCollectionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4b0088",
  null
  
)

export default component.exports